
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Create a root
const root = createRoot(document.getElementById("root")!);

// Force a refresh of metadata
document.title = "BubbleCare | Connected Care Networks for Your Loved Ones";

// Initial render
root.render(<App />);
